import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import TRANSLATIONS_VN from './vi/translations.json';
import TRANSLATIONS_EN from './en/translations.json';

export const defaultNS = 'translation';

export const resources = {
  vi: {
    translation: TRANSLATIONS_VN,
  },
  en: {
    translation: TRANSLATIONS_EN,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'vi', // Set Vietnamese as the default language
    fallbackLng: 'vi',
    debug: true,
    supportedLngs: ['vi', 'en'],
    nonExplicitSupportedLngs: false,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    resources,
  });

// Force Vietnamese as default if no language is stored locally
if (!localStorage.getItem('i18nextLng')) {
  i18n.changeLanguage('vi');
}

export default i18n;
